import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_EDITOR_SYMBOLS_DEFAULT } from '../queries/editorSymbolsDefault';
import { unmarshalGraphqlEdges } from '~graphql/utils';

export const fetchEditorSymbolsDefault = async () => {
  const graphQlClient = await getGraphQlClient();
  const response = await graphQlClient.query({
    variables: { order: ['order_ASC'] },
    query: FETCH_EDITOR_SYMBOLS_DEFAULT,
  });
  const items = unmarshalGraphqlEdges(response.data.editor_symbols_defaults)
    .edges;
  return {
    symbols: {
      allowNew: false,
      items: items.map((item) => ({
        id: item.objectId,
        url: item.img.url,
      })),
    },
  };
};
